import { createAction } from 'redux-actions';
import { PapiDeviation } from '@wix/da-types-papi';

export const setIsRepositioning = createAction('SET_IS_REPOSITIONING');

export const setSelectedDeviation = createAction<PapiDeviation>(
  'SET_SELECTED_DEVIATION'
);
